<div class="ada-login-page">
	<div class="ada-login-graphic-wrapper">
		<div class="ada-login-graphic">
			<ada-tile-graphic #LoginGraphic />
		</div>
		<div
			adaForwardCanvasMouseEvents
			class="ada-login-graphic-content"
		>
			@let _display = systemConfig.appDisplayName | async;
			@let _theme = themes.theme();
			@let _meta = auth.serverMetadata | async;

			@if (_theme) {
				@if (_theme.onPrimaryLogo || _theme.logo) {
					<img
						id="ada-login-logo"
						[attr.alt]="_display + ' Logo'"
						[attr.src]="_theme.onPrimaryLogo || _theme.logo"
					/>
				} @else {
					<ada-adaptiva-logo
						class="ada-display-block"
						[solidWhite]="true"
					/>
				}
			}

			@if (_meta) {
				@let _portalName = (_meta.cloudPortal ? 'Cloud' : 'Admin') + ' Portal';

				<h2>Welcome to {{ _display }} {{ _portalName }}</h2>
				<p>Log in to the {{ _portalName }} to manage your {{ _display }} environment</p>
			}
		</div>
	</div>
	<div class="ada-login-form ada-container ada-flex-center">
		<router-outlet style.display="none" />
	</div>
</div>
